import React, { useRef } from 'react'
import PageHeadSection from '../admin/components/PageHeadSection'
import SectionBoxContainer from '../../components/SectionBoxContainer'
import CategoriesList from './CategoriesList'
import CategoriesApp from './CategoriesApp'

export default function CategoriesBasePage() {

    const categoriesApp = new CategoriesApp()

    const newRefButton = useRef<HTMLButtonElement | null>(null)

    return(
        <div>

            <PageHeadSection pageName="categories" customActionButtons={[
                {
                    label: categoriesApp.messages.createShort,
                    onClick: () => {
                        if (newRefButton && newRefButton.current){
                            newRefButton.current.click()
                        }
                    },
                    icon: "new"
                }
            ]} />

            <SectionBoxContainer>
                <CategoriesList customNewCategoryButtonRef={newRefButton} />
            </SectionBoxContainer>
    
        </div>
    )
}